/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForGovernanceConfiguration extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForGovernanceConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForGovernanceConfiguration>): ProgressDetailsForGovernanceConfiguration {
        let obj = Object.assign(new ProgressDetailsForGovernanceConfiguration(), model);
        ProgressDetailsForGovernanceConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForGovernanceConfiguration>): ProgressDetailsForGovernanceConfiguration {
        if (!model) return null;
        return ProgressDetailsForGovernanceConfiguration.newInstance(<ProgressDetailsForGovernanceConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForGovernanceConfiguration) {
        if (!obj) return;

        models.ProgressDetailsForGovernanceConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForGovernanceConfiguration): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForGovernanceConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.settings) {
            for (let val of this.settings) {
                models.GovernanceConfigurationApplicationByContext.fixupPrototype(val);
            }
        }
    }

    /**
     * Governance Configuration settings
     */
    settings: Array<models.GovernanceConfigurationApplicationByContext>;

}
